import * as Sentry from '@sentry/browser';
import { checkSentryDSN } from './utils';
export function init(dsn, ignoreErrors = []) {
    if (checkSentryDSN(dsn)) {
        Sentry.init({
            dsn,
            ignoreErrors: [
                'PersistedQueryNotFound',
                /^(.*?(\bMissingRoute\b)[^$]*)/g,
                'PERSISTED_QUERY_NOT_FOUND'
            ].concat(ignoreErrors)
        });
        Sentry.configureScope(scope => {
            scope.setTag('BUILD_TARGET', 'client');
        });
    }
}
//# sourceMappingURL=client.js.map